var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-logo-wrap",attrs:{"to":"/"}},[(_vm.logo)?_c('img',{staticClass:"logo-img",attrs:{"src":_vm.logo}}):_vm._e(),(_vm.slogan && (_vm.isSideMenu ? (!_vm.logoFollowMenu || (_vm.logoFollowMenu && !_vm.menuCollapsed)) : true))?_c('span',{staticClass:"logo-slogan"},[_vm._v(" "+_vm._s(_vm.slogan)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }